import { versionFeature } from './version.reducer';

export const { selectIsNewVersionAvailable } = versionFeature;
